import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  plugins: [createPersistedState(
    {
      key: 'NewPriceSite',
      paths: [
        'viaList',
        'mode',
        'type',
        'teikiKind',
        'teikiValidity',
        'isMobile',
        'serializeData',
        'isAccept',
      ],
      // storage: window.sessionStorage,
    },
  )],
  strict: true,
  state: {
    viaList: [],
    mode: null,
    type: null,
    teikiKind: null,
    teikiValidity: null,
    isMobile: false,
    serializeData: [],
    isAccept: false,
    isLoading: false,
    alertModal: {
      showModal: false,
      message: undefined,
    },
    confirmModal: {
      showModal: false,
      message: undefined,
      callback: undefined,
    },
  },
  getters: {
    getIsLoading(state) { return state.isLoading; },
    getAlertModal(state) { return state.alertModal; },
    getConfirmModal(state) { return state.confirmModal; },
    getViaList(state) { return state.viaList; },
    getMode(state) { return state.mode; },
    getType(state) { return state.type; },
    getTeikiKind(state) { return state.teikiKind; },
    getTeikiValidity(state) { return state.teikiValidity; },
    getIsMobile(state) { return state.isMobile; },
    getSerializeData(state) { return state.serializeData; },
    getIsAccept(state) { return state.isAccept; },
  },
  mutations: {
    setViaList(state, value) {
      state.viaList = value;
    },
    setMode(state, value) {
      state.mode = value;
    },
    setType(state, value) {
      state.type = value;
    },
    setTeikiKind(state, value) {
      state.teikiKind = value;
    },
    setTeikiValidity(state, value) {
      state.teikiValidity = value;
    },
    setIsMobile(state, value) {
      state.isMobile = value;
    },
    setIsLoading(state, value) {
      state.isLoading = value;
    },
    addSerializeData(state, value) {
      state.serializeData.push(value);
    },
    sliceSerializeData(state, value) {
      state.serializeData = state.serializeData.slice(0, value);
    },
    setIsAccept(state, value) {
      state.isAccept = value;
    },
    reset(state) {
      state.viaList = [];
      state.mode = null;
      state.type = null;
      state.teikiKind = null;
      state.teikiValidity = null;
      state.serializeData.splice(0);
    },
    setAlertModal(state, message) {
      if (message !== undefined) {
        state.alertModal.showModal = true;
        state.alertModal.message = message;
      } else {
        state.alertModal.showModal = false;
      }
    },
    setConfirmModal(state, params) {
      if (params) {
        state.confirmModal.showModal = true;
        state.confirmModal.message = params.message;
        state.confirmModal.callback = params.callback;
      } else {
        state.confirmModal.showModal = false;
      }
    },
  },
  actions: {

  },
  modules: {

  }
})